import { ILLProductBase } from './ll-product-base.model';
import { ILLPart } from './ll-part.model';

export class ILLKit extends ILLProductBase {

  $type: string;
  parts: ILLPart[];
  productType: string;
  description: string;
  summaryDetails: string;
  topLevelXMLNodeName: string;
  hasActiveIngredients: boolean;
  hasCharacteristics: boolean;
  hasInactiveIngredients: boolean;
}
